export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";